import React from "react";
import ReactDOM from "react-dom";
import { Backdrop, CircularProgress } from "@material-ui/core";

const loaderRoot = document.getElementById("global-loader-root");

export function GlobalLoader({ open }) {
  if (!loaderRoot) return null;

  return ReactDOM.createPortal(
    <Backdrop open={open} style={{ zIndex: 2000, color: "#fff" }}>
      <CircularProgress color="inherit" />
    </Backdrop>,
    loaderRoot
  );
}
